module.exports = __webpack_public_path__ + "static/media/ic-menu.b9c09b75.svg";